function Spinner() {
    return (
      //   <div className='loadingSpinnerContainer'>
      //     <div className='loadingSpinner'></div>
      //   </div>
      //
      <div className="preloader">
        <div className="preloader-inner">
          <div className="preloader-icon">
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    );
  }
  
  export default Spinner